import { render, staticRenderFns } from "./DocumentPrescription.vue?vue&type=template&id=1fc17a2b&"
import script from "./DocumentPrescription.vue?vue&type=script&lang=js&"
export * from "./DocumentPrescription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports